import React from 'react';
import { styled } from 'dripsy';

import { Icon, Touchable } from '@components';

export const SCROLL_TO_TOP_BUTTON_SIZE = 52;

const TouchableContainer = styled(Touchable)({
  borderRadius: 'full',
  width: SCROLL_TO_TOP_BUTTON_SIZE,
  height: SCROLL_TO_TOP_BUTTON_SIZE,
  bg: '$primary200',
  alignItems: 'center',
  justifyContent: 'center',
  shadowRadius: SCROLL_TO_TOP_BUTTON_SIZE / 2,
  shadowColor: '$shadow',
  shadowOpacity: 0.4,
});

interface IScrollToTopButtonProps {
  onPress(): void;
}

export function ScrollToTopButton({
  onPress,
}: IScrollToTopButtonProps) {
  return (
    <TouchableContainer onPress={onPress}>
      <Icon name="arrow-up-light" size={24} />
    </TouchableContainer>
  );
}
